import styled from 'styled-components'

export const TableHead = styled.thead.attrs(props => ({
  boxSizing: 'border-box',
  ...props,
}))`
  box-sizing: ${props => props.boxSizing};
`
